import React, { useEffect, useState } from "react";
import SettingsEmptyState from '../../components/settings/SettingsEmptyState';
import {
  ConfirmDelete,
  MwInputText,
  MwSpinnerButton,
  NewButton,
  NewInputLang,
  MwSelectorAccount,
} from "../../components/ui";
import { IoMdAdd } from "react-icons/io";
import { BiEdit } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { useCurrent, useDelete, useFetch, usePost, usePut } from "../../hooks";

const TreasurySettings = ({ apiBaseUrl }) => {
  const { t } = useTranslation("settings");
  const [langar, setLangar] = useState(true);
  const [treasuryList, setTreasuryList] = useState([]);
  const [bankAccountsList, setBankAccountsList] = useState([]);
  const [treasuryCode, setTreasuryCode] = useState("");
  const [treasuryName, setTreasuryName] = useState("");
  const [treasuryEnName, setTreasuryEnName] = useState("");
  const [subAccount, setSubAccount] = useState("");
  const [bankId, setBankId] = useState("");
  const [error, setError] = useState({});
  const [onShow, setOnShow] = useState(false);
  const [selectedTreasuryId, setSelectedTreasuryId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingTreasuryId, setEditingTreasuryId] = useState(null);
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangId } =
    useCurrent();
  const { postData, loading } = usePost();
  const { loading: delloading, deleteItem } = useDelete();
  const canFetchContext = Boolean(
    currentTenantId && currentCompanyId && currentBranchId
  );
  const baseFinanceUrl = (apiBaseUrl || process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL || "").replace(/\/+$/, "");
  const buildFinanceUrl = (path) =>
    `${baseFinanceUrl}/${String(path || "").replace(/^\/+/, "")}`;
  const {
    data: incomesTreasuriesResult,
    loading: loadingTreasuries,
    refreshHandler: refetchTreasuries,
  } = useFetch(
    canFetchContext && baseFinanceUrl
      ? buildFinanceUrl(
          `treasuries/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        )
      : null
  );
  const { data: incomesCountResult, refreshHandler } = useFetch(
    canFetchContext && baseFinanceUrl
      ? buildFinanceUrl(
          `treasuries/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        )
      : null
  );
  const { data: bankAccountsResult } = useFetch(
    canFetchContext && baseFinanceUrl
      ? buildFinanceUrl(
          `banks-accounts/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        )
      : null
  );
  const { loading: saveloading, putData } = usePut();

  useEffect(() => {
    if (incomesCountResult && !isEditing) {
      setTreasuryCode((parseInt(incomesCountResult?.data) + 1).toString());
    }
  }, [incomesCountResult, isEditing]);

  useEffect(() => {
    if (incomesTreasuriesResult?.data) {
      setTreasuryList(incomesTreasuriesResult.data);
    }
  }, [incomesTreasuriesResult]);

  useEffect(() => {
    if (bankAccountsResult?.data) {
      setBankAccountsList(bankAccountsResult.data);
    }
  }, [bankAccountsResult]);

  const resolveBankLabel = (treasury) => {
    const bank = treasury?.bank;
    if (bank) {
      return currentLangId === "en" ? bank?.name_en : bank?.name_ar;
    }
    const bankIdValue = treasury?.bank_id;
    if (!bankIdValue) return "";
    const found = bankAccountsList.find(
      (b) => String(b.id) === String(bankIdValue)
    );
    return currentLangId === "en" ? found?.name_en : found?.name_ar;
  };

  const addTreasury = () => {
    let errors = {};

    if (!treasuryCode) errors.code = "Code Is Required";
    if (langar && !treasuryName) {
      errors.name_ar = "Arabic And English Name Is Required";
    }
    if (!langar && !treasuryEnName) {
      errors.name_en = "English And Arabic Name Is Required";
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    const treasuryData = {
      code: treasuryCode,
      name_ar: treasuryName || "_",
      name_en: treasuryEnName || "_",
      account_no: subAccount,
      ...(bankId ? { bank_id: Number(bankId) } : {}),
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    const resetForm = () => {
      setTreasuryCode("");
      setTreasuryName("");
      setTreasuryEnName("");
      setSubAccount("");
      setBankId("");
      setIsEditing(false);
      setEditingTreasuryId(null);
      setError({});
    };

    if (!baseFinanceUrl) return;
    if (!isEditing) {
      postData(
        buildFinanceUrl("treasuries"),
        treasuryData
      ).then(() => {
        refetchTreasuries();
        refreshHandler();
        resetForm();
      });
    } else {
      putData(
        buildFinanceUrl(`treasuries/${editingTreasuryId}`),
        treasuryData
      ).then(() => {
        refetchTreasuries();
        refreshHandler();
        resetForm();
      });
    }
  };

  const deleteTreasury = (id) => {
    if (!baseFinanceUrl) return;
    deleteItem(buildFinanceUrl(`treasuries/${id}`)).then(() => {
      refetchTreasuries();
      refreshHandler();
      setOnShow(false);
    });
  };

  return (
    <>
      {!treasuryCode ? (
        <div className="h-20 w-full justify-center items-center flex">
          <MwSpinnerButton />
        </div>
      ) : (
        <section className="flex flex-col flex-1">
          <ConfirmDelete
            onShow={onShow}
            setOnShow={setOnShow}
            onDeleteHandler={() => deleteTreasury(selectedTreasuryId)}
            loading={delloading}
            msg={t("treasury.treasurydel")}
          />
          <div className="flex flex-col md:flex-row md:flex-nowrap w-full items-end gap-2">
            <div className="w-full md:w-28">
              <MwInputText
                invalid={error?.code}
                disabled={true}
                label={t("treasury.treasurycode")}
                value={treasuryCode}
                onChange={(e) => setTreasuryCode(e.target.value)}
                classNameInput="w-[100%] text-center  flex-1  "
              />
            </div>
            <div className="w-full md:flex-1 md:min-w-64 flex flex-col justify-center">
              <NewInputLang
                invalid={error?.name_ar || error?.name_en}
                placeholder={t("treasury.treasurynameplaceholder")}
                label={t("treasury.treasuryname")}
                value={langar ? treasuryName : treasuryEnName}
                langar={langar}
                onChange={(value) => {
                  if (langar) {
                    setTreasuryName(value);
                  } else {
                    setTreasuryEnName(value);
                  }
                }}
                onChangeLang={() => setLangar(!langar)}
                classNameInput="w-[100%] flex-1"
              />
            </div>
            <div className="w-full md:flex-1 md:min-w-72">
              <MwSelectorAccount
                withLabel={true}
                placeholder={t("treasury.treasuryAccount")}
                classNamePrivate="flex-1 w-full"
                invalid={error?.account}
                initialValue={subAccount?.length > 0 ? subAccount : ""}
                onChangeCallback={(account) =>
                  setSubAccount(account.name_ar + "/" + account.account_no || "")
                }
              />
            </div>
            <div className="w-full md:w-52 flex flex-col">
              <label className="text-xs font-[700] px-1 text-[#261759]">
                {t("treasury.bank")}
              </label>
              <select
                value={bankId}
                onChange={(e) => setBankId(e.target.value)}
                className="h-9 bg-white border border-[#8D82B6] border-opacity-55 rounded-md text-sm text-[#251658] px-2"
              >
                <option value="">{t("treasury.bankNone")}</option>
                {bankAccountsList?.map((bank) => (
                  <option key={bank.id} value={bank.id}>
                    {currentLangId === "en" ? bank?.name_en : bank?.name_ar}
                  </option>
                ))}
              </select>
            </div>
            <div className="group">
              <NewButton onClick={addTreasury}>
                {loading || saveloading ? (
                  <MwSpinnerButton />
                ) : isEditing ? (
                  t("general.update")
                ) : (
                  <>
                    <IoMdAdd className="text-white text-lg group-hover:text-[#ffffff]" />
                    <p className="">{t("general.Add")}</p>
                  </>
                )}
              </NewButton>
            </div>
          </div>

          {loadingTreasuries && treasuryList?.length === 0 ? (
            <div className="h-40 flex justify-center items-center w-full">
              <MwSpinnerButton />
            </div>
          ) : treasuryList?.length > 0 ? (
            <>
              <>
                <div className="flex w-full mt-3 justify-around bg-[#F2F0FC] p-3 rounded-t-lg font-[800] text-[#251658] text-sm">
                  <div className="w-0 text-center">#</div>
                  <div className="w-52 text-center">
                    {t("treasury.treasurycode")}
                  </div>
                  <div className="w-52 text-center">
                    {t("treasury.treasuryname")}
                  </div>
                  <div className="w-52 text-center">
                    {t("treasury.treasuryaccountshow")}
                  </div>
                  <div className="w-52 text-center">{t("treasury.bank")}</div>
                  <div className="flex-1 text-center"></div>
                </div>
                <div className="divide-y  ">
                  {treasuryList.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-full border-b border-[#ddd0bf] border-opacity-25 cursor-pointer justify-around items-center p-3 text-[#251658] font-semibold text-sm"
                    >
                      <div className="w-1 text-center">{index + 1}</div>
                      <div className="w-52 text-center">{item?.code}</div>
                      <div className="w-52 text-center">
                        {currentLangId === "en" ? item?.name_en : item?.name_ar}
                      </div>
                      <div className="w-52 text-center">
                        {item?.account_no || item?.account}
                      </div>
                      <div className="w-52 text-center">
                        {resolveBankLabel(item) || ""}
                      </div>
                      <div className=" flex me-4 justify-end items-center flex-1 text-end gap-1">
                        <button
                          onClick={() => {
                            setIsEditing(true);
                            setEditingTreasuryId(item.id);
                            setTreasuryCode(item.code);
                            setTreasuryName(item.name_ar);
                            setTreasuryEnName(item?.name_en);
                            setSubAccount(
                              item.account_no ||
                                (item.account
                                  ? item.account.name_ar +
                                    "/" +
                                    item.account.account_no
                                  : "")
                            );
                            setBankId(
                              String(item?.bank_id ?? item?.bank?.id ?? "")
                            );
                          }}
                          className="text-blue-500 hover:text-blue-700 mx-2"
                        >
                          <BiEdit size={16} />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedTreasuryId(item.id);
                            setOnShow(true);
                          }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <RiDeleteBinLine size={16} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </>
          ) : (
            <div className=" h-[calc(100vh-230px)] ">
              <SettingsEmptyState msg="لا يوجد خزائن" />
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default TreasurySettings;
